export const getWorkersNumberOfRows = ({ settings }) => settings.pageSize;

export const getWorktimeMonth = ({ settings }) => settings.monthWorkTime;
